<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" @close='clear()' width="90%">
      <h2 class="text-center">绑定微信</h2>
      <div class="img">
          <img width="220" :src="url" />
      </div>
      <div class="text-center">
        <div class="button">
            请使用微信扫描二维码绑定
“JoyOrders”
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import { API_HOST, FILE_HOST } from '../../../services/constant.js'

export default {
  name: 'AddAddress',
  props: ['user'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      isEmptyErrors: true,
      errors: null,
      dialogFormVisible: false,
      loading: false,
      url: null,
      checkBindStatusInterval: null,
      seconds: 0
    }
  },
  methods: {
    show () {
        this.isEmptyErrors = true
        this.dialogFormVisible = true
        this.getBindUrl()
        this.getBindStatus()
        this.checkBindStatusInterval = setInterval(() => {
        this.getBindStatus()
        }, 2000)
    },
    getBindUrl () {
      let url = API_HOST +'/wechat/api.php?api=get_qr_url'
      this.$http.get(url).then(data =>{
          this.url = data.body.result
      })
    },

    getBindStatus () {
      let url = API_HOST +'/wechat/api.php?api=get_bind_status'
      this.$http.get(url).then(data =>{
          if(data.body.result === 'bind') {
            clearInterval(this.checkBindStatusInterval)
            this.dialogFormVisible = false
            this.$emit('success')

          }
      })
    },
    clear () {
        clearInterval(this.checkBindStatusInterval)
    }
  },

  beforeDestroy: function() {
      clearInterval(this.checkBindStatusInterval)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a {
  position: relative;
  top: 5px;
  cursor: pointer;
}
.img {
    text-align: center;
}
.button{
    width: 220px;
    background-color: #333 !important;
    border-color: #333 !important;
    color: #ffffff !important;
    display: inline-block;
    line-height: 1;
    border: 1px solid #dcdfe6;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 12px;
    border-radius: 20px;
    margin-bottom: 15px;
    span {
        display: inline-block;
        text-align: center;
        font-size: 12px;
        white-space: pre-line	;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user_center/components/WeChat.vue